export class EligibilityModel {
	isProfilePicExist: Boolean;
	isNational: Boolean;
	isEducation: Boolean;
	isMaxAge: Boolean;
	is2ndDivision: Boolean;
	is3rdDivision: Boolean;
	isMinimunEdu: Boolean;
}
